const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'nomic',
    assets: [{
            description: 'Nomic\'s native token.',
            denom_units: [{
                    denom: 'unom',
                    exponent: 0
                }, {
                    denom: 'nom',
                    exponent: 6
                }],
            base: 'unom',
            name: 'Nomic',
            display: 'nom',
            symbol: 'NOM',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg'
                }]
        }, {
            description: 'Bitcoin. On Cosmos.',
            denom_units: [{
                    denom: 'usat',
                    exponent: 0
                }, {
                    denom: 'nbtc',
                    exponent: 14
                }],
            base: 'usat',
            name: 'Nomic Bitcoin',
            display: 'nbtc',
            symbol: 'nBTC',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg'
            },
            traces: [{
                    type: 'bridge',
                    counterparty: {
                        chain_name: 'bitcoin',
                        base_denom: 'sat'
                    },
                    provider: 'Nomic'
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg'
                }]
        }]
};
export default info;
